import {
  type VehicleExtraImagePosition,
  type VehicleImagePosition,
  VehicleImagesSchema,
} from "@repo/types";
import type { DamagedCarImages } from "@/types/models/vehicle.types";

export type PhotoType = "before" | "after";

export type BasePhotoPosition = VehicleImagePosition;
export type ExtraPhotoPosition = VehicleExtraImagePosition;
export type PhotoPosition = BasePhotoPosition | ExtraPhotoPosition;

export type PhotoVehicle = {
  id: number;
  imagesBefore?: DamagedCarImages;
  imagesAfter?: DamagedCarImages;
};

type PhotoVehicleSource = { id: number; imagesBefore?: unknown; imagesAfter?: unknown };

export function toPhotoVehicle(source: PhotoVehicleSource): PhotoVehicle {
  return {
    id: source.id,
    imagesBefore:
      source.imagesBefore == null ? undefined : VehicleImagesSchema.parse(source.imagesBefore),
    imagesAfter:
      source.imagesAfter == null ? undefined : VehicleImagesSchema.parse(source.imagesAfter),
  };
}

export type ImageConfig = {
  key: keyof DamagedCarImages | ExtraPhotoPosition;
  tooltip: string;
  gridConfig?: {
    xs: number;
  };
};

export type SchemaImageButtonProps = {
  loading: boolean;
  isSuccess: boolean;
  handleImageClick: () => void;
  hasImage: boolean;
  tooltip: string;
  size?: "small" | "large";
};

export type ExtraImageButtonProps = {
  loading: boolean;
  isSuccess: boolean;
  handleImageClick: () => void;
  image: string;
  index: number;
  extraImageUrl?: string;
};

export type UploadButtonProps = {
  tooltip: string;
  getRootProps: () => any;
  getInputProps: () => any;
};

export type PhotoSectionProps = {
  type: PhotoType;
  vehicle: PhotoVehicle;
  images?: DamagedCarImages;
  isAdmin?: boolean;
  isPreview?: boolean;
  onImageClick?: (key: PhotoPosition) => void;
};

export type PhotoModalRootProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};
